module.exports = __webpack_public_path__ + "img/icon-store-information-title.svg";